import React from "react";
import { ProjectIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import { CompanyIcon, FolderIcon, LightIcon } from "@netapp/bxp-style/react-icons/General"
import { StyledLink, withTextOverflow } from "@netapp/bxp-design-system-react";
import { isNcl } from "utils/app/utils";
import styles from "../modules/app/components/MainHeader.module.scss";

export const getProjectIcon = () => isNcl() ? LightIcon : ProjectIcon;

// Renders the appropriate scope icon (Company/Folder/Project) based on resourceType.
export const ScopeTypeIcon = ({ resourceType, className, ...props }) => {
    const ResolvedProjectIcon = getProjectIcon();
    switch (resourceType) {
        case "organization":
            return <CompanyIcon className={className} {...props} />;
        case "folder":
            return <FolderIcon className={className} {...props} />;
        case "project":
            return <ResolvedProjectIcon className={className} {...props} />;
        default:
            return null;
    }
}

// Icon renderer for tree/accordion components with element.resourceType and element.isSelected.
export const createScopeIconRenderer = (unselectedClassName) => (element) => {
    const className = element?.isSelected ? "" : unselectedClassName;
    return <ScopeTypeIcon resourceType={element.resourceType} className={className} width="20" />;
}

export const IAMResourceIconRenderer = createScopeIconRenderer(styles["tenancy-icon-color"]);

export const StyledLinkWithOverflow = ({ className, children, to, ...props }) => {
    const Component = withTextOverflow(StyledLink);

    return (
        <Component
            to={to}
            variant="text"
            className={className}
            style={{ display: "inline-block" }}
            {...props}
        >
            {children}
        </Component>
    );
};